import '../style/AddCoefficient.css';
import type { PriceListRatioRowData } from 'gql/graphql';
import { RatioTypeEnum } from 'gql/graphql';

import { Checkbox } from '@consta/uikit/Checkbox';
import { useEffect, useMemo, useState } from 'react';

import type { TypeCheckedIds } from '../AddCoefficient';

interface UpdatePriceListRatioRowData extends PriceListRatioRowData {
    groupRow?: boolean;
}

interface ICoefficientRenderCheckbox {
    checkedIds: TypeCheckedIds;
    activeTabId: RatioTypeEnum;
    data: UpdatePriceListRatioRowData;
    handleChangeCheckbox: (row: PriceListRatioRowData) => ({ checked }: { checked: boolean }) => void;
    handleAllChangeCheckbox: (data: Record<string, boolean>) => () => void;
    currentRowData: PriceListRatioRowData[] | null;
    isHeadCheckbox: boolean;
}

export const CellRenderCheckbox = (props: ICoefficientRenderCheckbox) => {
    const {
        checkedIds,
        activeTabId,
        data,
        handleChangeCheckbox,
        handleAllChangeCheckbox,
        currentRowData,
        isHeadCheckbox,
    } = props;

    const [checkedAll, setCheckedAll] = useState<boolean>(false);

    const trueValuesLength = useMemo(
        () => Object.values(checkedIds[activeTabId]).filter((value) => value === true).length,
        [activeTabId, checkedIds],
    );

    useEffect(() => {
        setCheckedAll(currentRowData?.length === trueValuesLength);
    }, [currentRowData?.length, trueValuesLength]);

    const intermediate = trueValuesLength > 0 && trueValuesLength !== currentRowData?.length;

    const currentAllCheckId = currentRowData?.reduce((acc: { [x: string]: boolean }, curr: { id: string | number }) => {
        acc[curr.id] = true;

        return acc;
    }, {});

    const dataAllChange = useMemo(() => {
        if (checkedAll) {
            return {};
        }

        return currentAllCheckId || {};
    }, [checkedAll, currentAllCheckId]);

    if (isHeadCheckbox && activeTabId !== RatioTypeEnum.TechPartCoef) {
        return null;
    }

    const headRows = isHeadCheckbox || data?.groupRow;
    const currentChecked = headRows ? checkedAll : checkedIds[activeTabId][data?.id];
    const currentChange = headRows ? handleAllChangeCheckbox(dataAllChange) : handleChangeCheckbox(data);
    const currentIntermediate = headRows ? intermediate : false;
    const currentDisabled = isHeadCheckbox ? currentRowData?.length === 0 : false;

    return (
        <div className="CheckboxWrapper">
            <Checkbox
                className="CheckboxFocus"
                checked={currentChecked}
                onChange={currentChange}
                disabled={currentDisabled}
                intermediate={currentIntermediate}
            />
        </div>
    );
};

CellRenderCheckbox.displayName = 'CellRenderCheckbox';
